import { createContext, useContext, useState } from "react";
import { HistoryDocumentAg2r, getHistoryFicherAG2RLidl } from "../services/lidlDocumentService";

type DocumementAg2rContextType = {
    loading: boolean,
    hisitoryDocumentAg2r: HistoryDocumentAg2r[],
    getListHistoryDocumentAg2r: () => void
};

const DocumementAg2rContext = createContext<DocumementAg2rContextType>({
    loading: false,
    hisitoryDocumentAg2r: [],
    getListHistoryDocumentAg2r: () => {}
});

export const useDocumementAg2r = () => {
    return useContext(DocumementAg2rContext);
};

interface Props {
    children: React.ReactNode;
};

const DocumentAg2rProvider = ({ children }: Props): JSX.Element => {
    const [loading, setLoading] = useState<boolean>(false);
    const [hisitoryDocumentAg2r, setHisitoryDocumentAg2r] = useState<HistoryDocumentAg2r[]>([]);

    const getListHistoryDocumentAg2r = (): void => {
        setLoading(true);
        
        getHistoryFicherAG2RLidl()
        .then((history) => {
            setHisitoryDocumentAg2r(() => history);
        })
        .finally(() => setLoading(false));
    };

    return (
        <DocumementAg2rContext.Provider value={{
            loading, 
            hisitoryDocumentAg2r,
            getListHistoryDocumentAg2r
        }}>
            {children}
        </DocumementAg2rContext.Provider>
    )
}

export default DocumentAg2rProvider;